import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { jsx as o } from "react/jsx-runtime";
import { Fonts as e } from "@vds-core/typography";
import { calculateRem as i, getOS as t } from "@vds-core/utilities";
import { ColorTokens as n } from "@vds-tokens/color";
import { LayoutTokens as r } from "@vds-tokens/layout";
import { TypographyTokens as a } from "@vds-tokens/typography";
import { Component as d } from "react";
import s, { keyframes as l, css as p } from "styled-components";
import c from "../util/AccordionAnimation.js";
var m = r.space["6X"].value,
  u = r.space["8X"].value,
  f = l(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0px);\n  }\n\n  to {\n    transform: translateY(-16px);\n  }\n"]))),
  h = l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(20px);\n  }\n\n  to {\n    transform: translateY(0px);\n  }\n"]))),
  g = s.div.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-1izf72a-0"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var o = _ref.$opened;
    return p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    transition: padding 330ms linear;\n    animation-name: ", ";\n    animation-duration: 330ms;\n    animation-delay: 100ms;\n    animation-timing-function: linear;\n  "])), o ? h : f);
  }),
  v = s.div.withConfig({
    displayName: "StyledAccordionDetail",
    componentId: "VDS__sc-1izf72a-1"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  transition: padding 330ms;\n  > * {\n    margin: 0;\n    &:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n  &:active,\n  &:hover {\n    outline: none;\n  }\n  ", ";\n"])), function (_ref2) {
    var o = _ref2.surface;
    return "dark" === o ? n.elements.primary.ondark.value : n.elements.primary.onlight.value;
  }, function (_ref3) {
    var o = _ref3.viewport;
    return p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    ", ";\n    line-height: ", ";\n  "])), function (o) {
      return "mobile" === o ? e.VerizonNHGeTX : e.VerizonNHGeDS;
    }(o), i(function (o) {
      return "mobile" === o ? a.fontsize.body[12].value : a.fontsize.body[16].value;
    }(o)), "mobile" !== o && "\n      letter-spacing: ".concat(i(a.letterspacing.wide.value), ";"), i(function (o) {
      return "mobile" === o ? a.lineheight.body[16].value : a.lineheight.body[20].value;
    }(o)));
  }, i(8), function (_ref4) {
    var o = _ref4.$opened,
      e = _ref4.$paddingBottom;
    return o && "\n    padding-bottom: ".concat(i(e), ";\n    padding-top: 0;\n  ");
  });
var y = /*#__PURE__*/function (_d) {
  _inherits(y, _d);
  function y() {
    var _this;
    _classCallCheck(this, y);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(y).apply(this, arguments)), _this.isIos = "ios" === t();
    return _this;
  }
  _createClass(y, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var o = this.props.groupId;
      this.accordionDetailId = "accordionDetail_".concat(o), this.accordionAliasId = "accordionHeaderLabel_".concat(o);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        e = _this$props.opened,
        i = _this$props.children,
        t = _this$props.surface,
        n = _this$props.viewport,
        r = "mobile" === n,
        a = e ? "auto" : 0;
      return o(v, {
        viewport: n,
        $opened: e,
        surface: t,
        id: this.accordionDetailId,
        "aria-labelledby": this.accordionAliasId,
        tabIndex: this.isIos || e ? void 0 : -1,
        role: "region",
        "aria-hidden": !e && !this.isIos,
        $paddingBottom: r ? m : u,
        children: o(c, {
          height: a,
          opened: e,
          children: o(g, {
            $opened: e,
            children: i
          })
        })
      });
    }
  }]);
  return y;
}(d);
y.componentType = "AccordionDetail", y.defaultProps = {
  opened: !1,
  surface: "light",
  groupId: null,
  viewport: "desktop"
}, y.componentType = "AccordionDetail";
export { y as default };